/*
 * Gift Baskets To Miami: add-ons pop-up (sections/gbm-addons.liquid).
 * "Add to cart" on a basket opens the pop-up instead of going straight to the cart.
 * The basket and the extras the shopper picked are added together in one request,
 * then the cart page opens. If anything here fails, the theme's normal Add to cart runs.
 */
(() => {
  if (window.gbmAddons) return;
  window.gbmAddons = true;

  const dialog = document.querySelector('[data-gbm-addons]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const es = dialog.dataset.lang === 'es';
  const T = es
    ? {
        continue: 'Continuar al carrito',
        addN: (n) => `Agregar ${n} ${n === 1 ? 'extra' : 'extras'} y continuar`,
        adding: 'Agregando…',
        basket: 'Canasta',
        extras: (n) => `${n} ${n === 1 ? 'extra' : 'extras'}`,
        total: 'Total',
        error: 'Lo sentimos, no pudimos agregarlo al carrito. Inténtalo de nuevo.',
      }
    : {
        continue: 'Continue to cart',
        addN: (n) => `Add ${n} ${n === 1 ? 'extra' : 'extras'} & continue`,
        adding: 'Adding…',
        basket: 'Basket',
        extras: (n) => `${n} ${n === 1 ? 'extra' : 'extras'}`,
        total: 'Total',
        error: "Sorry, we couldn't add that to your cart. Please try again.",
      };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(es ? 'es-US' : 'en-US', {
        style: 'currency',
        currency: dialog.dataset.currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const cards = Array.from(dialog.querySelectorAll('[data-gbm-addon]'));
  const summary = dialog.querySelector('[data-gbm-summary]');
  const errorEl = dialog.querySelector('[data-gbm-error]');
  const skipBtn = dialog.querySelector('[data-gbm-skip]');
  const confirmBtn = dialog.querySelector('[data-gbm-confirm]');
  const confirmLabel = dialog.querySelector('[data-gbm-confirm-label]');
  const main = dialog.querySelector('[data-gbm-main]');
  const body = dialog.querySelector('[data-gbm-body]');
  const more = dialog.querySelector('[data-gbm-more]');
  const tabs = Array.from(dialog.querySelectorAll('[data-gbm-tab]'));
  const groups = Array.from(dialog.querySelectorAll('[data-gbm-group]'));
  const smooth = () => (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
  let form = null;
  let busy = false;

  const selected = () => cards.filter((c) => c.getAttribute('aria-pressed') === 'true');

  // Scroll cues: highlight the tab of the group in view; show "More add-ons" and a fade
  // until the shopper reaches the bottom of the list.
  let cueFrame = null;
  const updateCues = () => {
    cueFrame = null;
    if (!body) return;
    const atEnd = body.scrollTop + body.clientHeight >= body.scrollHeight - 12;
    if (more) more.hidden = atEnd;
    if (main) main.classList.toggle('has-more', !atEnd);
    let current = groups[0];
    groups.forEach((g) => {
      if (g.offsetTop - 40 <= body.scrollTop) current = g;
    });
    if (atEnd && groups.length) current = groups[groups.length - 1];
    tabs.forEach((t) => t.setAttribute('aria-current', String(!!current && t.dataset.gbmTab === current.dataset.gbmGroup)));
  };
  const queueCues = () => {
    if (cueFrame === null) cueFrame = window.requestAnimationFrame ? requestAnimationFrame(updateCues) : setTimeout(updateCues, 16);
  };
  const scrollToGroup = (group) => {
    if (body && group) body.scrollTo({ top: Math.max(0, group.offsetTop - 8), behavior: smooth() });
  };
  if (body) {
    body.addEventListener('scroll', queueCues, { passive: true });
    body.addEventListener('load', queueCues, true); // lazy images change the height
    window.addEventListener('resize', queueCues);
  }
  tabs.forEach((tab) =>
    tab.addEventListener('click', () => scrollToGroup(groups.find((g) => g.dataset.gbmGroup === tab.dataset.gbmTab)))
  );
  if (more) {
    more.addEventListener('click', () => {
      const next = groups.find((g) => g.offsetTop > body.scrollTop + 40);
      if (next) scrollToGroup(next);
      else body.scrollTo({ top: body.scrollTop + body.clientHeight * 0.8, behavior: smooth() });
    });
  }

  const basketInfo = () => {
    const data = new FormData(form);
    const quantity = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
    let price = null;
    try {
      const scope = form.closest('product-info') || document;
      const json = scope.querySelector('variant-selects [data-selected-variant]');
      const variant = json && JSON.parse(json.textContent);
      if (variant && String(variant.id) === String(data.get('id'))) price = variant.price;
    } catch (e) {}
    return { data, quantity, price };
  };

  const render = () => {
    const picked = selected();
    const n = picked.length;
    const extras = picked.reduce((sum, c) => sum + (parseInt(c.dataset.price, 10) || 0), 0);
    const { quantity, price } = basketInfo();
    confirmLabel.textContent = busy ? T.adding : n ? T.addN(n) : T.continue;
    skipBtn.hidden = n === 0;
    if (price === null) {
      summary.innerHTML = n ? `<strong>${T.extras(n)}: ${money(extras)}</strong>` : '';
      return;
    }
    const basket = price * quantity;
    summary.innerHTML = n
      ? `${T.total}: <strong>${money(basket + extras)}</strong><small>${T.basket} ${money(basket)} + ${T.extras(
          n
        )} ${money(extras)}</small>`
      : `${T.basket}: <strong>${money(basket)}</strong>`;
  };

  const setBusy = (state) => {
    busy = state;
    confirmBtn.setAttribute('aria-busy', String(state));
    confirmBtn.disabled = state;
    skipBtn.disabled = state;
    render();
  };

  const showError = (message) => {
    errorEl.textContent = message || '';
    errorEl.hidden = !message;
  };

  const open = (productForm) => {
    form = productForm;
    cards.forEach((c) => c.setAttribute('aria-pressed', 'false'));
    showError('');
    setBusy(false);
    document.documentElement.classList.add('gbm-addons-open');
    dialog.showModal();
    if (body) body.scrollTop = 0;
    // Focus the pop-up itself (not the close button) so no focus ring flashes on open.
    const panel = dialog.querySelector('.gbm-addons__panel');
    if (panel) panel.focus({ preventScroll: true });
    updateCues();
    queueCues();
  };

  const close = () => {
    if (busy) return;
    dialog.close();
  };

  dialog.addEventListener('close', () => document.documentElement.classList.remove('gbm-addons-open'));
  dialog.addEventListener('cancel', (e) => {
    if (busy) e.preventDefault();
  });
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) close(); // click on the dimmed backdrop
  });
  dialog.querySelector('[data-gbm-close]').addEventListener('click', close);

  cards.forEach((card) =>
    card.addEventListener('click', () => {
      if (busy || card.disabled) return;
      card.setAttribute('aria-pressed', card.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      showError('');
      render();
    })
  );

  const addToCart = (withExtras) => {
    if (busy || !form) return;
    const { data, quantity } = basketInfo();
    const basket = { id: Number(data.get('id')), quantity };
    const properties = {};
    for (const [key, value] of data.entries()) {
      const m = /^properties\[(.+)\]$/.exec(key);
      if (m && typeof value === 'string' && value !== '') properties[m[1]] = value;
    }
    if (Object.keys(properties).length) basket.properties = properties;
    if (data.get('selling_plan')) basket.selling_plan = Number(data.get('selling_plan'));

    const items = [basket];
    if (withExtras) selected().forEach((c) => items.push({ id: Number(c.dataset.variantId), quantity: 1 }));

    setBusy(true);
    showError('');
    const routes = window.routes || {};
    fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json().then((json) => ({ ok: response.ok, json })))
      .then(({ ok, json }) => {
        if (!ok || json.status) throw new Error(json.description || json.message || '');
        window.location.href = routes.cart_url || '/cart';
      })
      .catch((error) => {
        setBusy(false);
        showError(error && error.message ? error.message : T.error);
      });
  };

  confirmBtn.addEventListener('click', () => addToCart(true));
  skipBtn.addEventListener('click', () => addToCart(false));

  // Open the pop-up instead of the theme's own Add to cart, on the main product form only.
  document.addEventListener(
    'submit',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLFormElement)) return;
      if (!target.closest('product-info[id^="MainProduct"] product-form')) return;
      const submit = target.querySelector('[type="submit"]');
      if (submit && (submit.disabled || submit.getAttribute('aria-disabled') === 'true')) return;
      if (!new FormData(target).get('id')) return;
      try {
        event.preventDefault();
        event.stopImmediatePropagation();
        open(target);
      } catch (error) {
        // Something went wrong: fall back to the theme's normal Add to cart.
        if (window.console) console.warn('[gbm-addons] fallback to normal add to cart', error);
        dialog.open && dialog.close();
        target.closest('product-form')?.onSubmitHandler?.(event);
      }
    },
    true
  );
})();
